/* global localStorage */

import Vue from 'vue'
import Vuex from 'vuex'
import User from './user'
import Users from './users'
import CurrentInbox from './current_inbox'
import Clients from './clients'
import TagsCollection from './tags'
import MailboxesCollection from './mailboxes'
import Teams from './teams'
import CurrentReportMailbox from './current_report_mailbox'
import ReportDates from './report_dates'
import Fields from './fields'
import Client from './client'
import TaskTemplates from './task_templates'
import Draft from './draft'
import Message from './message'
import MessageForm from './message_form'
import Notifications from './notifications'
import SubfolderForm from './subfolder_form'
import Tickets from './tickets'
import Boards from './boards'
import Customers from './customers'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    User,
    Users,
    CurrentInbox,
    Clients,
    TagsCollection,
    MailboxesCollection,
    Teams,
    CurrentReportMailbox,
    ReportDates,
    Fields,
    Client,
    TaskTemplates,
    Draft,
    Message,
    MessageForm,
    Notifications,
    SubfolderForm,
    Tickets,
    Boards,
    Customers
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js